export function orderLineTotal(line, fallbackPrice) {
  const quantity = Number(line?.quantity || 0);
  const unitPrice = Number(line?.unitPrice ?? line?.finalPrice ?? fallbackPrice ?? 0);
  const adjustment = Number(line?.discount || 0);
  if (!adjustment) return Number((unitPrice * quantity).toFixed(2));

  const referencePrices = [line?.listUnitPriceSnapshot, fallbackPrice]
    .filter((value) => value !== null && value !== undefined && value !== '')
    .map(Number)
    .filter(Number.isFinite);
  const adjustmentAlreadyInUnitPrice = line?.unitPrice !== null
    && line?.unitPrice !== undefined
    && referencePrices.some((referencePrice) => (
      Math.abs((unitPrice - referencePrice) - adjustment) < 0.011
    ));
  const total = unitPrice * quantity * (adjustmentAlreadyInUnitPrice ? 1 : (1 + adjustment / 100));
  return Number(total.toFixed(2));
}
